import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SignInForm from '../components/SignInForm';
import Logo from '../components/Logo';
import { ArrowLeft } from 'lucide-react';

export default function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState<string>('');

  useEffect(() => {
    // Extract email from URL query parameters
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location]);

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleCreateAccount = () => {
    navigate('/register');
  };

  const handleSuccessfulLogin = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <button
          onClick={handleBackToHome}
          className="absolute top-4 sm:top-8 left-4 sm:left-8 text-gray-600 hover:text-gray-900 flex items-center space-x-2"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Home</span>
        </button>
        
        <div className="flex justify-center">
          <Logo className="h-12 md:h-16" />
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <SignInForm 
            onCreateAccount={handleCreateAccount} 
            onSuccessfulLogin={handleSuccessfulLogin}
            initialEmail={email}
          />
        </div>
      </div>
    </div>
  );
}